import { Fragment } from 'react';

import { Typography } from '@breezeventures/ui-kit/typography';
import cn from 'classnames';

import type { FormNavigationProps } from './types';

export const FormNavigation = ({ sections }: FormNavigationProps) => {
  return (
    <div className={cn('flex w-50 max-w-50 flex-col items-start')}>
      {sections.map((section) => (
        <Fragment key={section.id}>
          <div
            className={cn(
              `flex w-full flex-col items-start rounded-lg px-3 py-3`,
              {
                'bg-skeleton': section.isActive,
              }
            )}
          >
            <Typography.Text
              tag="span"
              size="xs"
              weight="medium"
              color="primary"
              className="w-full wrap-break-word"
              aria-current={section.isActive ? 'step' : undefined}
            >
              {section.title}
            </Typography.Text>
          </div>

          {section.items?.map((item) => (
            <div
              key={item.id}
              className={cn(
                'flex w-full flex-col items-start rounded-lg py-2 pr-3 pl-6',
                { 'bg-skeleton': item.isActive }
              )}
            >
              <div className="flex w-full items-center">
                <Typography.Text
                  tag="span"
                  size="s"
                  weight="medium"
                  color={item.isActive ? 'primary' : 'secondary'}
                  className="w-full wrap-break-word"
                  aria-current={item.isActive ? 'step' : undefined}
                >
                  {item.label}
                </Typography.Text>
              </div>
            </div>
          ))}
        </Fragment>
      ))}
    </div>
  );
};
